/* eslint-disable react/prop-types */
/* eslint-disable no-case-declarations */
import React, { lazy, Suspense } from 'react';

export default function index(props) {
  switch (props?.style) {
    case 'template_two':
      const TemplateTwo = lazy(() => import('./template-two'));
      return (
        <Suspense fallback={<></>}>
          <TemplateTwo {...props} />
        </Suspense>
      );
    case 'template_three':
      const TemplateThree = lazy(() => import('./template-three'));
      return (
        <Suspense fallback={<></>}>
          <TemplateThree {...props} />
        </Suspense>
      );
    default:
      const TemplateOne = lazy(() => import('./template-one'));
      return (
        <Suspense fallback={<></>}>
          <TemplateOne {...props} />
        </Suspense>
      );
  }
}
